import { render, staticRenderFns } from "./ElDrmFlexText.vue?vue&type=template&id=68d2b2f8"
import script from "./ElDrmFlexText.vue?vue&type=script&lang=js"
export * from "./ElDrmFlexText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports